module.exports = __webpack_public_path__ + "media/images/redesign-images/home/carousel/sorority-desktop-2dbe3ca196ccefdf9dd8c1f3bfead2da.jpg";